var _path, _line, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 58,
    viewBox: "0 0 60 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 5.75C18 5.33579 18.3358 5 18.75 5H40.25C40.6642 5 41 5.33579 41 5.75V19.5C41 25.8513 35.8513 31 29.5 31C23.1487 31 18 25.8513 18 19.5V5.75Z",
    stroke: "black",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 13,
    x2: 41,
    y2: 13,
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47 54.0002C47.5523 54.0002 48 53.5525 48 53.0002V47.0002C48 40.3728 42.6274 35.0002 36 35.0002L23 35.0002C16.3726 35.0002 11 40.3728 11 47.0002L11 53.0002C11 53.5525 11.4477 54.0002 12 54.0002C12.5523 54.0002 13 53.5525 13 53.0002L13 47.0002C13 41.4774 17.4772 37.0002 23 37.0002L36 37.0002C41.5229 37.0002 46 41.4774 46 47.0002V53.0002C46 53.5525 46.4477 54.0002 47 54.0002Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.698 45.2515L22.1166 36.2518",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6982 45.251L37 36.0991",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHr);
export default __webpack_public_path__ + "static/media/hr.45271a8b6d0089a6dfae68313987fe96.svg";
export { ForwardRef as ReactComponent };